import { render, staticRenderFns } from "./inbox_detail.vue?vue&type=template&id=1a5b9763"
import script from "./inbox_detail.vue?vue&type=script&lang=js"
export * from "./inbox_detail.vue?vue&type=script&lang=js"
import style0 from "./inbox_detail.vue?vue&type=style&index=0&id=1a5b9763&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports